import { Route, Routes, Navigate } from "react-router-dom";
import Home from "../Components/Home";
import Module1 from "../Components/Module1";
import Module2 from "../Components/Module2";
import Module3 from "../Components/Module3";
import Module1Quiz from "../Components/Module1Quiz";
import Module2Quiz from "../Components/Module2Quiz";
import Module3Quiz from "../Components/Module3Quiz";
import Register from "../Components/Register";
import AdminDashboard from "../Components/Admin/AdminDashboard";
import Certificate from "../Components/Admin/Certificate";
import GoogleReview from "../Components/GoogleReview";
import UserCertificate from "../Components/UserCertificate";
import Login from "../Components/Login";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import Module4 from "../Components/Module4";
import Module4Quiz from "../Components/Module4Quiz";

const AllRoutes = () => {
  return (
    <Routes>
      {/* ==================== PUBLIC ROUTES ==================== */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* ==================== USER PROTECTED ROUTES ==================== */}
      <Route element={<ProtectedRoute allowedRoles={["User"]} />}>
        <Route path="/home" element={<Home />} />
        <Route path="/module1" element={<Module1 />} />
        <Route path="/module2" element={<Module2 />} />
        <Route path="/module3" element={<Module3 />} />
        <Route path="/module4" element={<Module4 />} />

        <Route path="/quiz/module1/:certification" element={<Module1Quiz />} />
        <Route path="/quiz/module2/:certification" element={<Module2Quiz />} />
        <Route path="/quiz/module3/:certification" element={<Module3Quiz />} />
        <Route path="/quiz/module4/:certification" element={<Module4Quiz />} />

        <Route path="/googleReview" element={<GoogleReview />} />
        <Route path="/user-certificate" element={<UserCertificate />} />
      </Route>

      {/* ==================== ADMIN PROTECTED ROUTES ==================== */}
      <Route element={<ProtectedRoute allowedRoles={["Admin"]} />}>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/certificate" element={<Certificate />} />
      </Route>

      {/* ==================== FALLBACK ROUTES ==================== */}
      <Route path="/" element={<Navigate to="/register" replace />} />
      <Route path="*" element={<Navigate to="/register" replace />} />
    </Routes>
  );
};

export default AllRoutes;
